import {
  LoadingActions,
  LoadingActionTypes
} from './loading.actions';

export interface LoadingState {
  isLoading: number;
}

export const initialState: LoadingState = {
  isLoading: 0,
};

export function reducer(
  state = initialState,
  action: LoadingActions,
): LoadingState {
  switch (action.type) {
    case LoadingActionTypes.SetLoading:
      console.error('The Action SetLoading is deprecated and has no effect');
      break;

    case LoadingActionTypes.IsLoaded:
      return { ...state, isLoading: state.isLoading > 0 ? state.isLoading - 1 : 0 };

    case LoadingActionTypes.IsLoading:
      return { ...state, isLoading: state.isLoading + 1 };

    default:
      return state;
  }
}
